export class CampaignReport {
    constructor(campaignReport) {
        this.total_email_sent      = campaignReport.total_email_sent;
        this.total_sms_sent        = campaignReport.total_sms_sent;
        this.total_receive_message = campaignReport.total_receive_message;
        this.total_claim           = campaignReport.total_claim;
        this.total_redemption      = campaignReport.total_redemption;
        this.claim_percent         = campaignReport.claim_percent;
        this.redemption_percent    = campaignReport.redemption_percent;
        this.total_income          = campaignReport.total_income;
        this.total_expense         = campaignReport.total_expense;
        this.percent_expense       = campaignReport.percent_expense;
    }
}